import * as busyIndicator from "client_legacy/ndaw/busyIndicator";
import { alertBar } from "client_legacy/ndaw/alertBar";
import { EmailClient, IEmailClientEditDraftFeature } from "client_legacy/Email/emailClient";
import { HttpRequestError } from "client/Api/httpClient";
import { ListLocationModel } from "client/Api/Documents/SharePoint/common";
import { localize } from "client_legacy/ndaw/culture";
import {
	draftWithAttachedSharePointFile,
	draftWithAttachedWebDavFile,
	draftWithLink,
	FailedToCreateDraft,
	SuccessfullyCreatedDraft
} from "client/Api/Email/SendFile/sendFile";
import { ContainerType } from "client_legacy/ndaw/busyIndicator";

export function sendWebDavFileAsAttachment(
	serverId: number,
	fileId: string,
	emailClient: EmailClient & IEmailClientEditDraftFeature
): void {
	sendFileAsAttachment(
		() => draftWithAttachedWebDavFile({
			serverId: serverId,
			fileId: fileId
		}),
		emailClient
	);
}

export function sendSharePointFileAsAttachment(
	fileId: number,
	location: ListLocationModel,
	emailClient: EmailClient & IEmailClientEditDraftFeature,
	busyIndicatorTarget?: ContainerType
): void {
	sendFileAsAttachment(
		() => draftWithAttachedSharePointFile({
			fileId: fileId,
			location: location
		}),
		emailClient,
		busyIndicatorTarget
	);
}

function sendFileAsAttachment(
	requestFactory: () => Promise<SuccessfullyCreatedDraft>,
	emailClient: EmailClient & IEmailClientEditDraftFeature,
	busyIndicatorTarget?: ContainerType
): void {
	busyIndicator.show(busyIndicatorTarget);

	requestFactory()
		.then(
			(response) => {
				emailClient.editDraft({
					draftId: response.draftId,
					representsANewlyGeneratedDraft: true
				});
			},
			(response) => {
				let message: string | undefined;
				try {
					if (response instanceof HttpRequestError && response.statusCode === 400) {
						const errorResponse = response.readJson<FailedToCreateDraft>();
						message = errorResponse.message;
					}
				} catch (e) {
					console.error(e);
				}
				alertBar.showTextAlert(message ?? localize("_GeneralErrorMessage"), "error");
			}
		)
		.finally(
			() => busyIndicator.hide(busyIndicatorTarget)
	);
}

export async function sendLink(
	link: string,
	emailClient: EmailClient & IEmailClientEditDraftFeature
): Promise<void> {
	const response: SuccessfullyCreatedDraft = await draftWithLink(
		{ url: link }
	);

	emailClient.editDraft({
		draftId: response.draftId,
		representsANewlyGeneratedDraft: true
	});
}
